// extracted by mini-css-extract-plugin
export const video = "video-module--video--3jKEN";